<template>
    <div>
    <b-modal ref="payment-list" :title="$t('accounting.account.registrationPayDocList')"
             @ok="closePopup"
             @cancel="closePopup"
             :no-close-on-backdrop="true"
             :no-close-on-esc="true">

        <div class="">
            <div class="card">
                <div class="card-body">
                  <div class="table-wrapper">
                    <table class="table">
                        <thead class="modal-table-head">
                        <tr>
                            <th>
                                № #
                            </th>
                            <th>
                                {{$t("accounting.account.date")}}
                            </th>
                            <th>
                                {{$t("accounting.account.number")}}
                            </th>
                            <th>
                                {{$t("accounting.account.totalAmount")}}
                            </th>
                            <th  style="display: table-cell;">
                                {{$t("realEstate.field.action")}}
                            </th>
                        </tr>
                        </thead>
                        <tbody class="modal-table-body">
                        <template>
                            <tr v-for="(it,index) in results" :key="it.id">
                                <td>{{index+1}}</td>
                                <td>{{format_date(it.paymentDocumentDate)}}</td>
                                <td>{{it.paymentDocumentNumber}}</td>
                                <td>{{it.price | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td style="display: table-cell;">
                                    <button class="all-btn table-action eedit-b " data-original-title="Edit"
                                            @click="showPaymentDocumentEditModal(it)" v-if="it.evaluationPaymentSource==='MANUAL'">
                                        <i class="fa fa-edit"></i>
                                    </button>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                  </div>
                </div>
            </div>
            <payment-document-edit-modal></payment-document-edit-modal>

        </div>
    </b-modal>
    </div>
</template>

<script>

    import initFilterModel from '@/shared/filter';
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {format_date} from '@/shared/utils';
    import PaymentDocumentEditModal from '@/views/accounting/PaymentDocumentEditModal';


    export default {
        name: "PaymentDocumentList",
        components: {
            'b-modal': bModal,
            PaymentDocumentEditModal,
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                filter: initFilterModel(),
                show: false,
                processing: false,
                numericTypes: numericTypes,
                data: {},
                results: [],
                id: null
            }
        },
        methods: {
            format_date(value){
                if (value) {
                    return format_date(value)
                }
                return null;
            },
            showPaymentDocumentEditModal(data) {
                this.$eventBus.$emit('showPaymentDocumentEditModal', data);
            },
            closePopup(){
                console.log("closePopup");
                this.$eventBus.$emit('LegalAccountList', {});
            }
        },
        created() {
            this.$eventBus.$on('showPaymentDocumentListModal', (data) => {
                const vm = this;
                console.log(data.id);
                this.id =  data.id;
                this.$http.get('/payment/documents/list/' + data.id)
                    .then(res => {
                        if (!res.data.code) {
                            vm.results = res.data;
                            // console.log(vm.results);
                            // console.log(vm.$refs['payment-list']);
                            setTimeout(() => {
                                vm.$refs['payment-list'].show();
                            }, 100);

                        }
                    }, err => {
                        console.log(err);
                    });
            });
        }
    }
</script>

<style scoped>

</style>
